import FieldProto from "../../../../proto/field-proto"

const debug = false
// const debug = "number_checkValueIsValid"

export default function number_checkValueIsValid(field: FieldProto, inputValue: number | string | null) {
    let regexpString = '(-)?([0-9]+)(.[0-9]+)?'

    debug && console.log(debug, 'process regexpString', regexpString)

    const regexp = new RegExp(regexpString)

    let match = null
    if (!_.isNil(inputValue)) {
        switch (typeof inputValue) {
            case 'number':
                match = inputValue.toString().match(regexp)
                break

            default:
                match = inputValue.match(regexp)
                break
        }
    }

    debug && console.log(debug, 'process', match !== null, field.positiveOnly, field.integersOnly, match, inputValue)

    if (!match)                             return false
    if (field.positiveOnly && match[1])     return false
    if (field.integersOnly && match[3])     return false
    if (!field.isValueValid(inputValue))    return false

    return true
}